import * as React from "react";

import type { DesignaliProps } from "../../types";

export const ArrowBigUp = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
        ref={forwardedRef}
      >
        <path d="M5 9v6" />
        <path d="M9 9h3V5l7 7-7 7v-4H9V9z" />
      </svg>
    );
  },
);

export default ArrowBigUp;
